'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ToggleInput from '@nib-components/toggle-input';
const Checkbox = _ref => {
  let {
    checked = false,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(ToggleInput, {
    "data-mesh-component": "CHECKBOX",
    ...otherProps,
    selected: checked,
    type: "checkbox"
  });
};
Checkbox.displayName = 'Checkbox';
export default Checkbox;